import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import slackLaptopSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=false!images/svg/onboarding/slack-laptop.svg'
import arrowSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/curved-arrow-small.svg'
import style from './style.styl'

class ProfileDetailsPreview extends Component {
  render = () => (
    <div className={style.ProfileDetailsPreview}>
      <div className={style.SidebarContainer}>
        <div className={style.SlackPreviewContainer}>
          <div className={style.PreviewSlackChat}></div>
          <div className={style.PreviewLaptop}>
            <IconSVG src={slackLaptopSrc} />
          </div>
        </div>
      </div>
      <div className={style.ArrowText}>
        <p style={{ maxWidth: "200px", textAlign: "center", margin: "0", color: "#FFFFFF" }}>
          This is what Drift notifications look like in slack
        </p>
        <IconSVG
            src={arrowSrc}
            style={{ margin: "0" }}
        />
      </div>
    </div>
  )
}

export default ProfileDetailsPreview



// WEBPACK FOOTER //
// ./src/scripts/components/SlackInstall/Preview/index.js